import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); }
  catch (e) { return null; }
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function keyMatches(sub, keyBytes) {
  try {
    const existing = sub.options && sub.options.applicationServerKey;
    if (!existing) return false;
    const a = new Uint8Array(existing);
    if (a.length !== keyBytes.length) return false;
    for (let i = 0; i < a.length; i++) if (a[i] !== keyBytes[i]) return false;
    return true;
  } catch (e) { return false; }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Ten telefon/przeglądarka nie obsługuje powiadomień push.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Nie udzielono zgody na powiadomienia.");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerServiceWorker());
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  const keyBytes = urlBase64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  // Jeśli istniejąca subskrypcja została utworzona INNYM kluczem VAPID (np. po zmianie kluczy
  // na serwerze), FCM odrzuci push (403). Kasujemy ją i subskrybujemy ponownie aktualnym kluczem.
  if (sub && !keyMatches(sub, keyBytes)) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (e) {}
    try { await sub.unsubscribe(); } catch (e) {}
    sub = null;
  }
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: keyBytes,
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (e) {}
    await sub.unsubscribe();
  }
}
